// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"444":"0a560899","921":"18f6149c"}[chunkId] + ".chunk.js";
};